import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";
import { useCookieConsent } from "@/lib/cookieConsent";
import { CLEARBOOK_BOOKING_URL } from "@/lib/clearbook";

export const Footer = () => {
  const { openBanner } = useCookieConsent();
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="font-display text-3xl md:text-4xl leading-tight">
              Skal vi <em className="text-[color:var(--fk-gold)]">samarbejde?</em>
            </h3>
            <p className="mt-6 text-white/60 max-w-md font-light">
              Vi står klar med døgnvagt, hurtig respons og klare svar. Ring eller
              book online, så finder vi næste skridt.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                data-testid="footer-call"
                href={ASSETS.brand.phoneTel}
                className="px-6 py-4 text-[11px] tracking-[0.24em] uppercase bg-[color:var(--fk-gold)] text-black hover:bg-[color:var(--fk-gold-hi)] transition-colors text-center"
              >
                Ring {ASSETS.brand.phone}
              </a>
              <a
                data-testid="footer-booking"
                href={CLEARBOOK_BOOKING_URL}
                className="px-6 py-4 text-[11px] tracking-[0.24em] uppercase border border-white/20 text-white hover:border-[color:var(--fk-gold)] hover:text-[color:var(--fk-gold)] transition-colors text-center"
              >
                Book online
              </a>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <div className="eyebrow mb-5">Selskab</div>
            <ul className="space-y-3 text-sm text-white/70 font-light">
              <li><Link to="/om-os" className="hover:text-white">Om os</Link></li>
              <li><Link to="/kontakt" className="hover:text-white">Kontakt</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow mb-5">Ydelser</div>
            <ul className="space-y-3 text-sm text-white/70 font-light">
              <li><Link to="/ydelser/rottebekaempelse" className="hover:text-white">Rottebekæmpelse</Link></li>
              <li><Link to="/ydelser/kloakopgaver" className="hover:text-white">Kloakopgaver</Link></li>
              <li><Link to="/ydelser/serviceaftale" className="hover:text-white">Serviceaftale</Link></li>
              <li><Link to="/ydelser/no-dig" className="hover:text-white">No-dig</Link></li>
              <li><Link to="/ydelser/spul-rens" className="hover:text-white">Spul & Rens</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Kontakt</div>
            <ul className="space-y-3 text-sm text-white/70 font-light">
              <li>Døgnvagt · <a href={ASSETS.brand.phoneTel} className="hover:text-white">{ASSETS.brand.phone}</a></li>
              <li><a href={`mailto:${ASSETS.brand.email}`} className="hover:text-white">{ASSETS.brand.email}</a></li>
              <li>{ASSETS.brand.address}</li>
            </ul>
          </div>
        </div>

        {/* Credentials strip */}
        <div className="mt-20 pt-10 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div
            data-testid="footer-aa-badge"
            className="flex items-center gap-6 md:gap-8"
          >
            <div className="bg-white p-4 md:p-5 flex items-center justify-center shrink-0">
              <img
                src="/badges/aa-dnb.jpg"
                alt="AA Høj kreditværdighed 2026 · Dun & Bradstreet"
                className="h-24 md:h-32 w-auto"
              />
            </div>
            <div className="max-w-sm">
              <div className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--fk-gold)] mb-2">
                Kreditværdighed
              </div>
              <div className="font-display text-2xl md:text-3xl leading-tight mb-2">
                Høj kreditværdighed — AA
              </div>
              <p className="text-sm text-white/60 font-light leading-relaxed">
                Vurderet af Dun&nbsp;&&nbsp;Bradstreet i 2026 — den højeste
                kreditværdigheds­kategori for danske virksomheder.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:items-end gap-2 shrink-0">
            <img
              src="/logo-farumkloak.png"
              alt="Farum Kloak"
              className="h-7 w-auto"
            />
            <div className="text-xs text-white/40 tracking-[0.18em] uppercase">
              © {new Date().getFullYear()} Farum Kloak ApS · Autoriseret kloakmester
            </div>
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={openBanner}
              className="mt-2 text-[11px] tracking-[0.18em] uppercase text-white/50 hover:text-[color:var(--fk-gold)] transition-colors"
            >
              Cookieindstillinger
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
